import { render, staticRenderFns } from "./EmployeeTrafficFineOfficialView.vue?vue&type=template&id=22c26e46&"
import script from "./EmployeeTrafficFineOfficialView.vue?vue&type=script&lang=js&"
export * from "./EmployeeTrafficFineOfficialView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports